import React from "react";
import { useNavigate } from "react-router-dom";
import "./CarCard.css";
const CarCard = () => {
  const navigate = useNavigate();
  const handleBookNow =() => {
    navigate("/BookNow");
  };
  return (
    <>
      <div className="car-card-container">
      <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Mahindra-Major.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Mahindra-Major-DI-Turbo" luxury Our GrandFather Type Old SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Camper.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Bolero-Camper-Gold-VX-4X4" and luxury SUV PickUp Truck for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Scorpio-Gateway.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Scorpio-Gateway" and luxury SUV PickUp Truck for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Scorpio-S11.png" L alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Scorpio-Classic-S11" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Scorpio-N.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Scorpio-N-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Mahindra-Thar.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Mahindra-Thar-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/XUV500-Sportz.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "XUV-500" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/XUV-700.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "XUV-700" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Thar-Roxx.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Mahindra-Thar-Roxx-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Tata-Safari-Storme.png" L alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia Tata-Safari-Strome-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Tata-Safari.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Tata-Safari" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Toyota-Fortuner-Legender.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Toyota-Fortuner-Legender-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Toyota-Fortuner.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>Mafia Car Rental</h3>
            <p>Rent the best Mafia "Toyota-Fortuner-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Toyota-Hilux.png" L alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Toyota-Hilux-4X4" and luxury SUV PickUp Truck for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Ford-Endeavour.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Ford-Endeavour-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage//MG-Gloster.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "MG-Gloster-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Force-Gurkha.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Force-Gurkha-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Force-Gurkha-five-door.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Force-Gurkha-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Force-One.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Force-One" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Jeep-Grandcherokee-Laredo.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Jeep-Grandcherokee" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Jeep-Wrangler.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Jeep-Wrangler" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/Mitsubishi-Pajero.png" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia "Mitsubishi-Pajero-4X4" and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/1.jpeg" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
        <div className="car-card">
          <div className="car-image">
            <img src="cardimage/1.jpeg" alt="Car" className="car-image-img" />
          </div>
          <div className="car-card-content">
            <h3>mafia Car Rental</h3>
            <p>Rent the best Mafia and luxury SUV cars for your next adventure!</p>
            <button className="car-card-button" onClick={handleBookNow}>BOOK NOW</button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CarCard;
